import React from "react";
import Button from "./../../../components/Button/Button";

/** Filtres groupe + mois + bouton Afficher */
const FiltersBar = ({
  groups,
  months,
  selectedGroupId,
  setSelectedGroupId,
  selectedMonth,
  setSelectedMonth,
  loading,
  onShow,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
      <div>
        <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
          Groupe
        </label>
        <select
          value={selectedGroupId}
          onChange={(e) => setSelectedGroupId(e.target.value)}
          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          disabled={loading}
        >
          <option value="">Sélectionnez un groupe</option>
          {groups.map((g) => (
            <option key={g.id} value={g.id}>
              {g.nom}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
          Mois
        </label>
        <select
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          disabled={loading}
        >
          <option value="">Sélectionnez un mois</option>
          {months.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-end">
        <Button
          text={loading ? "Chargement…" : "Afficher"}
          onClick={onShow}
          className="!bg-white !text-slate-900 !hover:bg-white/90 !rounded-xl !shadow-md gap-1 w-full"
          disabled={loading || !selectedGroupId || !selectedMonth}
        />
      </div>
    </div>
  );
};

export default FiltersBar;
